export default "__VITE_ASSET__BAoGtLWz__"